// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PIECurtainLoader__wrapper___3hbrJ","loaderWrapper":"PIECurtainLoader__loaderWrapper___1NTKb","message":"PIECurtainLoader__message___31sBq"};